module.exports = __webpack_public_path__ + "img/map-marker-alt.2bff3598.svg";